import { get, post } from "@/services/http/platformServer";

export interface JdOutboundDropshipOrder {
    id: number;
    originalId: string;
}

export interface DropshipOrderOutboundResult {
    /**
     * 错误信息
     */
    message?: string;
    /**
     * 订单ID
     */
    orderId: number;
    /**
     * 订单编号
     */
    originalId: string;
    /**
     * 是否成功
     */
    success: boolean;
}

/** 对厂直订单进行出库操作 */
export function jdOutBound(shopId: number, orders: JdOutboundDropshipOrder[]) {
    return post<DropshipOrderOutboundResult[]>(shopId, "/jd/order/dropship/outbound", { shopId, orders });
}
